import React from 'react';
import { Plus } from 'lucide-react';
import { Conversation } from '../utils/types';
import ConversationItem from './ConversationItem';
import SearchBar from './SearchBar';

interface ConversationListProps {
    conversations: Conversation[];
    activeConversation: number;
    searchQuery: string;
    onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onConversationSelect: (id: number) => void;
    onNewConversation: () => void;
    onEditConversation: (id: number, newTitle: string) => void;
    onDeleteConversation: (id: number) => void;
}

const ConversationList: React.FC<ConversationListProps> = ({
                                                               conversations,
                                                               activeConversation,
                                                               searchQuery,
                                                               onSearchChange,
                                                               onConversationSelect,
                                                               onNewConversation,
                                                               onEditConversation,
                                                               onDeleteConversation
                                                           }) => {
    const filteredConversations = conversations.filter(
        conv => conv.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="h-full flex flex-col max-h-screen">
            <div className="p-4 bg-gray-100 border-b border-gray-300">
                <h1 className="text-xl font-semibold text-blue-600 text leading-[42px]">Xelacore AI</h1>
            </div>

            <div className="p-4 border-b border-gray-200">
                <SearchBar
                    placeholder="Search conversations..."
                    value={searchQuery}
                    onChange={onSearchChange}
                    className="w-full"
                />
            </div>

            <div className="flex-1 overflow-y-auto">
                <div className="p-2">
                    {filteredConversations.length > 0 ? (
                        filteredConversations.map(conversation => (
                            <ConversationItem
                                key={conversation.id}
                                conversation={conversation}
                                isActive={activeConversation === conversation.id - 1}
                                onClick={() => onConversationSelect(conversation.id)}
                                onEdit={onEditConversation}
                                onDelete={onDeleteConversation}
                            />
                        ))
                    ) : (
                        <div className="p-3 text-gray-500 text-center">
                            No conversations found
                        </div>
                    )}
                </div>
            </div>

            <div className="p-4 border-t border-gray-200">
                <button
                    className="w-full py-2 px-4 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
                    onClick={onNewConversation}
                >
                    <Plus size={18} className="mr-2" />
                    New Conversation
                </button>
            </div>
        </div>
    );
};

export default ConversationList;